// ActivityLogsViewer — admin Activity Logs panel (logins / saves / balance / errors),
// extracted from src/App.jsx (C1 refactor, behavior-preserving). Moved verbatim; only
// imports adjusted. Rendered by AdminPanel (still in App.jsx). Was previously hooks-inside-IIFE
// (illegal React) — already fixed to a proper component before extraction.
import React from "react";
import { API_BASE } from '../lib/endpoints.js';
import { getSessionToken, resetSessionTokenCache } from '../utils/session.js';
import { todayGMT2 } from '../utils.js';

function ActivityLogsViewer() {
  // FIX: was hooks-inside-IIFE (illegal React). Now a proper component.
  const [logDate, setLogDate] = React.useState(todayGMT2());
  const [logType, setLogType] = React.useState('activity');
  const [logEntries, setLogEntries] = React.useState([]);
  const [logLoading, setLogLoading] = React.useState(false);
  const [logTotal, setLogTotal] = React.useState(0);
  const [logDates, setLogDates] = React.useState([]);
  const [logOpen, setLogOpen] = React.useState(false);

  const loadDates = async () => {
    resetSessionTokenCache(); // v28.10 FIX: fresh token
    const d = await fetch(`${API_BASE}/admin/logs/dates`, {headers:{'Authorization':`Bearer ${localStorage.getItem('blitz_token') || getSessionToken()}`}}).then(r=>r.json()).catch(()=>({dates:[]}));
    setLogDates(d.dates||[]);
  };
  const loadLogs = React.useCallback(async () => {
    setLogLoading(true);
    resetSessionTokenCache(); // v28.10 FIX: fresh token
    const d = await fetch(`${API_BASE}/admin/logs?type=${logType}&date=${logDate}&lines=300`, {headers:{'Authorization':`Bearer ${localStorage.getItem('blitz_token') || getSessionToken()}`}}).then(r=>r.json()).catch(()=>({entries:[]}));
    setLogEntries((d.entries||[]).reverse());
    setLogTotal(d.total||0);
    setLogLoading(false);
  }, [logType, logDate]); // FIX: auto-refresh when type/date changes

  // FIX: auto-refresh when dropdowns change (was manual-only)
  // 2026-05-16 ESLint burndown: loadLogs added к deps (useCallback-stable, deps
  // [logType, logDate] already covered by effect deps → no behavior change).
  React.useEffect(() => { if (logOpen) loadLogs(); }, [logType, logDate, logOpen, loadLogs]);

  return (
    <div style={{ marginTop: 32, background: "#F8FAFC", border: "1px solid #E2E8F0", borderRadius: 14, padding: "20px 24px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#334155", display: "flex", alignItems: "center", gap: 8 }}>📋 Activity Logs</h2>
        <button onClick={() => { setLogOpen(p=>!p); if (!logOpen) { loadDates(); loadLogs(); } }}
          style={{ padding: "6px 14px", borderRadius: 8, background: logOpen?"#E2E8F0":"#6366F1", border: "none", color: logOpen?"#475569":"#FFF", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          {logOpen ? "Close" : "Open Logs"}
        </button>
      </div>
      {logOpen && (<>
        <div style={{ display: "flex", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
          <select value={logType} onChange={e=>{setLogType(e.target.value);}} style={{ padding: "6px 10px", borderRadius: 8, border: "1px solid #E2E8F0", fontSize: 13 }}>
            <option value="activity">Activity (logins, saves, balance)</option>
            <option value="error">Errors only</option>
            <option value="app">All events</option>
          </select>
          <select value={logDate} onChange={e=>setLogDate(e.target.value)} style={{ padding: "6px 10px", borderRadius: 8, border: "1px solid #E2E8F0", fontSize: 13 }}>
            <option value={todayGMT2()}>Today</option>
            {logDates.filter(d=>d!==todayGMT2()).map(d=><option key={d} value={d}>{d}</option>)}
          </select>
          <button onClick={loadLogs} disabled={logLoading} style={{ padding: "6px 14px", borderRadius: 8, background: "#6366F1", border: "none", color: "#FFF", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
            {logLoading ? "Loading..." : "🔄 Refresh"}
          </button>
          <button onClick={() => {
            const text = logEntries.map(e => `[${e.ts||""}] ${e.level||""} [${e.module||""}] ${e.message||e.raw||""}`).join("\n");
            navigator.clipboard.writeText(text).then(()=>alert("Logs copied!"));
          }} style={{ padding: "6px 14px", borderRadius: 8, background: "#10B981", border: "none", color: "#FFF", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
            📋 Copy
          </button>
          <span style={{ fontSize: 12, color: "#94A3B8", alignSelf: "center" }}>Total: {logTotal} entries</span>
        </div>
        <div style={{ background: "#0F172A", borderRadius: 10, padding: 12, maxHeight: 400, overflowY: "auto", fontFamily: "'JetBrains Mono',monospace", fontSize: 10 }}>
          {logEntries.length === 0 && !logLoading && <div style={{ color: "#475569" }}>No logs for this date/type.</div>}
          {logEntries.map((e, i) => {
            const isError = e.level === "ERROR" || e.level === "CRASH" || (e.raw && e.raw.includes("ERROR"));
            const isWarn = e.level === "WARN";
            const color = isError ? "#EF4444" : isWarn ? "#F59E0B" : e.level === "ACTIVITY" ? "#10B981" : "#94A3B8";
            const text = e.raw || `[${(e.ts||"").slice(11,19)}] ${e.level||""} [${e.module||""}] ${e.message||""} ${Object.entries(e).filter(([k])=>!["ts","level","module","message"].includes(k)).map(([k,v])=>`${k}=${JSON.stringify(v)}`).join(" ")}`;
            return <div key={i} style={{ color, lineHeight: 1.5, borderBottom: "1px solid #1E293B", padding: "2px 0", wordBreak: "break-all" }}>{text}</div>;
          })}
        </div>
      </>)}
    </div>
  );
}

export { ActivityLogsViewer };
export default ActivityLogsViewer;
